import Vue from 'vue'
import Router from 'vue-router'
import WebShop from '@/components/WebShop'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'WebShop',
    component: WebShop,
  }
];

const router = new Router({
	// History 模式
    // mode: 'history',
    // base: '/app/',
    routes
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js